import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Box,
  Typography,
  IconButton,
  Chip,
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';

const shortcuts = [
  { category: 'Navigation', items: [
    { keys: ['⌘', 'K'], description: 'Search issues' },
    { keys: ['?'], description: 'Show keyboard shortcuts' },
  ]},
  { category: 'Board', items: [
    { keys: ['N'], description: 'Create new issue' },
    { keys: ['C'], description: 'Create new issue' },
    { keys: ['R'], description: 'Toggle reports/charts' },
  ]},
  { category: 'Issue Detail', items: [
    { keys: ['E'], description: 'Edit issue (when dialog open)' },
    { keys: ['Esc'], description: 'Close dialog / Cancel' },
    { keys: ['Enter'], description: 'Submit (in forms)' },
  ]},
];

export const KeyboardShortcuts: React.FC = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      const target = e.target as HTMLElement;
      if (target instanceof HTMLInputElement || target instanceof HTMLTextAreaElement) return;
      if (target.isContentEditable || target.closest('[contenteditable="true"]')) return;
      if (e.key === '?' && !e.metaKey && !e.ctrlKey) {
        e.preventDefault();
        setOpen(true);
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);

  return (
    <Dialog open={open} onClose={() => setOpen(false)} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        Keyboard Shortcuts
        <IconButton onClick={() => setOpen(false)} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        {shortcuts.map(group => (
          <Box key={group.category} sx={{ mb: 3 }}>
            <Typography variant="subtitle2" color="text.secondary" fontWeight={600} sx={{ mb: 1 }}>
              {group.category}
            </Typography>
            {group.items.map((shortcut, i) => (
              <Box key={i} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 0.75 }}>
                <Typography variant="body2">{shortcut.description}</Typography>
                <Box sx={{ display: 'flex', gap: 0.5 }}>
                  {shortcut.keys.map((key, j) => (
                    <React.Fragment key={j}>
                      {j > 0 && <Typography variant="caption" color="text.secondary" sx={{ lineHeight: '24px' }}>+</Typography>}
                      <Chip
                        label={key}
                        size="small"
                        variant="outlined"
                        sx={{ height: 24, minWidth: 28, fontSize: '0.75rem', fontFamily: 'monospace' }}
                      />
                    </React.Fragment>
                  ))}
                </Box>
              </Box>
            ))}
          </Box>
        ))}
      </DialogContent>
    </Dialog>
  );
};

export default KeyboardShortcuts;
